import axios from "axios";
import { environment } from "../Environment/environment";
import { handleError } from "./ErrorHandlingService";

const apiToken = "e532c7ba3d7dd872df0f67576c161969";

// Create a cancel token source to cancel pending requests on 401
let cancelTokenSource = axios.CancelToken.source();

// Track if we're in a 401 error state to prevent multiple error handling
let isIn401ErrorState = false;

const axiosInstance = axios.create({
  baseURL: environment.API_URL,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    // "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    var userDetails = null;
    var admin_id = 0;
    try {
      userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;
      admin_id = userDetails?.admin_id || 0;
    } catch (error) {
      console.error("Error in request interceptor: ", error);
    }

    if (config.method === "get") {
      config.params = {
        ...config.params,
        token: apiToken,
        admin_id: admin_id,
      };
    } else if (config.method === "post") {
      // config.data = {
      //   ...config.data,
      //   token: apiToken,
      //   admin_id: admin_id,
      // };
      if (config.data instanceof FormData) {
        config.data.append("token", apiToken);
        config.data.append("admin_id", admin_id);
      } else {
        config.data = {
          ...config.data,
          token: apiToken,
        };
        
        if (config.data.admin_id === undefined || config.data.admin_id === null) {
          config.data.admin_id = admin_id;
        }
      }
    } else if (config.method === "put") {
      config.data = {
        ...config.data,
        token: apiToken,
        admin_id: admin_id,
      };
    }
    // const token = localStorage.getItem("token");
    // console.log("Token >> ", token);
    // if (token) {
    //   config.headers["Authorization"] = token;

    // }
    // Skip auth header if config has `skipAuth: true`

    if (!config.skipAuth) {
      const token = localStorage.getItem("token");

      console.log("Token >> ", token);

      if (token) {
        config.headers["Authorization"] = token;
      }
    }

    // Add cancel token to all requests
    config.cancelToken = cancelTokenSource.token;

    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => {
    const newToken = response.headers["authorization"];
    if (newToken) {
      localStorage.setItem("token", newToken);
    }

    // Handle success responses centrally
    if (response.data?.status === "success") {
      // Extract entity and action from URL
      const method = response.config.method;

      if (method === "get") {
        return response;
      }

      if (response.data.message) {
        //handleSuccess(response.data.message);
      }
    }

    return response;
  },
  (error) => {
    // If it's a 401 error, handle it specially to prevent cascade
    if (error.response && error.response.status === 401) {
      console.log("401 error detected, cancelling all pending requests");

      // Only handle 401 once to prevent multiple error handling
      if (!isIn401ErrorState) {
        isIn401ErrorState = true;

        // Cancel all pending requests
        cancelTokenSource.cancel(
          "Session expired, cancelling pending requests"
        );

        // Create a new cancel token source for future requests
        cancelTokenSource = axios.CancelToken.source();

        // Reset the 401 state after a delay to allow for cleanup
        setTimeout(() => {
          isIn401ErrorState = false;
        }, 1000);
      }

      // Call handleError to show the login popup immediately
      handleError(error);
      return Promise.reject(error);
    }

    // For non-401 errors, use the normal error handling
    handleError(error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
